import { IconButton, Typography } from '@/components';
import React, { useEffect, useState } from 'react';
import { LuX } from 'react-icons/lu';
import styles from './Popup.module.css';

export interface PopupProps extends React.PropsWithChildren {
  title: string;
  defaultOpen?: boolean;
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

const Popup = ({
  title,
  defaultOpen = false,
  open = undefined,
  onOpen = () => {},
  onClose = () => {},
  ...props
}: PopupProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(open || defaultOpen);

  useEffect(() => {
    if (typeof open === 'boolean') {
      if (open) openPopup();
      else closePopup();
    }
  }, [open]);

  const openPopup = () => {
    if (isOpen) return;
    setIsOpen(true);
    setTimeout(() => onOpen(), 0);
  };

  const closePopup = () => {
    if (!isOpen) return;
    setIsOpen(false);
    setTimeout(() => onClose(), 0);
  };

  if (!isOpen) return <></>;

  return (
    <div className={styles.overlay} onClick={closePopup}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <Typography variant={'bodyLarge'}>{title}</Typography>
          <div className={styles.closeButton}>
            <IconButton
              className={styles.closeButton}
              onClick={closePopup}
              icon={<LuX />}
            />
          </div>
        </div>
        <div className={styles.content}>{props.children}</div>
      </div>
    </div>
  );
};

export default Popup;
